export default __webpack_public_path__ + "static/media/PitcherAngle-RightHandPitcher.9fa2ce69.png";